import Link from "next/link";
import { FC } from "react";

const Logo: FC = () => {
  return (
    <>
      <Link href="/">
        <img src="/static/bobcat/images/logo-bobcat-black.svg" />
      </Link>
      {/* language=CSS */}
      <style jsx>
        {`
          img {
            width: 144px;
            height: 40px;
          }
        `}
      </style>
    </>
  );
};

export default Logo;
